import { AppModule } from 'app/module';
import './styles.scss';
import Template from 'module/companyProspect/template.hbs';

export class CompanyProspect extends AppModule {
    setTemplate() {
        this.template = Template;
    }

    domBindings() {
        return {
            toggleShowMore: '.m-companyProspect__toggleShowMore',
            shortText: '.m-companyProspect__shortText',
            detailText: '.m-companyProspect__detailText',
        };
    }

    getPropsFromDom() {
        return {
            shortText: this.dom.shortText ? this.dom.shortText.innerHTML : '',
            active: this.dom.shortText !== null,
            detailText: this.dom.detailText ? this.dom.detailText.innerText : '',
            showButton: this.dom.toggleShowMore !== null,
        };
    }

    domEvents() {
        if (this.dom.toggleShowMore) {
            this.dom.toggleShowMore.addEventListener('click', () => this.toggleMore());
        }
    }

    toggleMore() {
        this.updateProps({
            showMore: !this.props.showMore,
            theme: 'agp',
        }, true);
    }
}
